module.exports = __webpack_public_path__ + "public/media/lavie.png";


//////////////////
// WEBPACK FOOTER
// ./images/partners/lavie.png
// module id = ./images/partners/lavie.png
// module chunks = 0